export default {
  en: {
    user: 'User Management',
    resetPassword: 'Reset Password',
    username: 'Username',
    email: 'E-mail',
    resetPasswordBy: 'Reset Password By',
    generatePassword: 'Generate password and send to email.',
    manualPassword: 'Manual',
    newPassword: 'New Password',
    pleaseEnterNewPassword: 'Please enter new password',
    resetPasswordSuccess: 'Reset password success.',
    apply: 'Reset Password',
    cancel: 'Cancel'
  },
  th: {
    user: 'การจัดการผู้ใช้งาน',
    resetPassword: 'เปลี่ยนรหัสผ่าน',
    username: 'ชื่อผู้ใช้',
    email: 'อีเมล',
    resetPasswordBy: 'เปลี่ยนรหัสผ่านโดย',
    generatePassword: 'สุ่มรหัสผ่านแล้วส่งไปยังอีเมล',
    manualPassword: 'กำหนดเอง',
    newPassword: 'รหัสผ่านใหม่',
    pleaseEnterNewPassword: 'กรุณาใส่รหัสผ่าน',
    resetPasswordSuccess: 'เปลี่ยนรหัสผ่านสำเร็จ',
    apply: 'เปลี่ยนรหัสผ่าน',
    cancel: 'ยกเลิก'
  }
}
